var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toast.visible)?_c('div',{staticClass:"global-toast",class:_vm.toast.type},[_vm._v(" "+_vm._s(_vm.toast.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }